export const Logo = () => (
  <svg width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M4.14505 32C3.61068 32 3.15912 31.8184 2.7917 31.4558C2.42428 31.0933 2.24023 30.6477 2.24023 30.1204V22.2692C2.62672 20.0893 4.04515 18.5256 6.01307 17.6999C10.1356 15.9702 16.7696 17.0131 19.6715 19.5796L5.80011 2.0878C5.56743 1.86728 5.42282 1.55661 5.42282 1.21156C5.42282 0.552596 5.95194 0.0168633 6.61186 0H6.64275H15.8987C34.381 0 34.381 32 15.8987 32H4.14505Z"
      fill="white"
    />
    <path
      d="M10.4809 7.99059L5.79965 2.08715C5.56697 1.86663 5.42236 1.55596 5.42236 1.21091C5.42236 0.552596 5.95148 0.0168633 6.6114 0H6.64229H15.8982C26.7639 0 31.2387 11.0591 29.3286 20.175C28.9743 10.6128 17.8037 14.8118 10.4809 7.99059Z"
      fill="#96A0B0"
    />
    <path
      d="M20.9601 22.8173C20.966 22.912 20.9686 23.008 20.9686 23.104C20.9686 26.4326 17.51 29.1904 12.9957 29.6768L6.0127 17.7C10.2101 15.7659 16.7022 16.6629 19.6646 19.5738C20.4106 20.4656 20.8838 21.5461 20.9601 22.8173Z"
      fill="#535E72"
    />
  </svg>
);
